<div fxLayout="column">
  <div class="select-area">
    <div fxLayout="row" fxLayoutAlign="center center" class="placeholder-container">
      <mat-icon class="placeholder-icon">photo_size_select_actual</mat-icon>
      <p class="placeholder">{{uploadFilesText}}</p>
    </div>
    <input type="file" ng2FileSelect [uploader]="uploader" multiple />
  </div>
  <mat-chip-set #chipList aria-label="Allow File Format" class="attachment-chips mt10">
    <mat-chip fxLayout fxLayoutALign="start center" *ngFor="let item of uploader.queue">
      <mat-icon class="upload-success">check_circle</mat-icon>
      <span class="file-name">{{ item?.file?.name }}</span>
      <mat-icon matChipRemove (click)="remove(item)">cancel</mat-icon>
    </mat-chip>
  </mat-chip-set>
</div>